import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import App from './App.vue'


// FontAwesome 配置
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { 
  faUserCircle, 
  faSyncAlt, 
  faSignInAlt, 
  faKey, 
  faSignOutAlt 
} from '@fortawesome/free-solid-svg-icons'

// 添加图标到库中
library.add(faUserCircle, faSyncAlt, faSignInAlt, faKey, faSignOutAlt)

const app = createApp(App)

// 注册FontAwesome组件
app.component('font-awesome-icon', FontAwesomeIcon)

app.use(ElementPlus, {
  locale: zhCn,
})

app.mount('#app')
